import { authService } from './AuthService';
import ApiUrlHelper from '../helpers/ApiUrlHelper';
import { http } from '../helpers/http';
import { Constants } from '../helpers/Auth';

class UserService {
  private authService: any;

  constructor() {
    this.authService = authService;
  }

  public async getCurrentUser(): Promise<any> {
    const url = ApiUrlHelper.constructEndpoint({ endpoint: 'CALLBACK' });
    return http.get(url).catch((error) => {
      if (error?.response?.status === 401) {
        return this.authService.login();
      }
      throw error;
    });
  }

  public async getUserFlowSignature(userID: string): Promise<any> {
    return http.get(`${Constants.coreApiRoot}/userflow/verification/${userID}`);
  }
}

const instance = new UserService();
Object.freeze(instance);

export default instance;
